import { render, staticRenderFns } from "./CustomOperationsTable.vue?vue&type=template&id=05c875e4&scoped=true"
import script from "./CustomOperationsTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomOperationsTable.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CustomOperationsTable.vue?vue&type=style&index=0&id=05c875e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c875e4",
  null
  
)

export default component.exports